import axios from "axios";
//
// const BASE_URL = "http://10.200.39.222:8000";
 const BASE_URL = 'https://api.themailwhale.in';
//const BASE_URL = "http://10.200.39.100:8080";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// ✅ Add access token to all requests
axiosInstance.interceptors.request.use(
  (config) => {
    const tokenData = localStorage.getItem("authTokens");
    if (tokenData) {
      try {
        const parsed = JSON.parse(tokenData);
        const accessToken = parsed?.access;
        if (accessToken) {
          config.headers.Authorization = `Bearer ${accessToken}`;
        }
      } catch (err) {
        console.error("Invalid token data", err);
      }
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// ✅ Handle 401 errors and queue retries
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    const isTokenExpired =
      error.response?.status === 401 && !originalRequest._retry;

    if (isTokenExpired) {
      originalRequest._retry = true;

      if (isRefreshing) {
        // Wait until the token is refreshed
        return new Promise((resolve, reject) => {
          failedQueue.push({
            resolve: (token) => {
              originalRequest.headers.Authorization = `Bearer ${token}`;
              resolve(axiosInstance(originalRequest));
            },
            reject,
          });
        });
      }

      isRefreshing = true;

      try {
        const tokenData = JSON.parse(localStorage.getItem("authTokens"));
        const refreshToken = tokenData?.refresh;

        const response = await axios.post(
          `${BASE_URL}/api/mobile/resident/token/refresh/`,
          { refresh: refreshToken },
        );

        const newAccessToken = response.data.access;
        const newRefreshToken = response.data.refresh || refreshToken; // Use new if provided

        const newTokenData = {
          access: newAccessToken,
          refresh: newRefreshToken, // ✅ Persist this too
        };

        // ✅ Save both updated tokens
        localStorage.setItem("authTokens", JSON.stringify(newTokenData));

        processQueue(null, newAccessToken);

        // Retry the original request with new token
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError, null);
        localStorage.removeItem("authTokens");
        console.warn("Token expired — redirecting to login.");
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
